<div>
    <aeg-loader v-if="processCounterLoading" :message="'Loading ' + processCounterText" />
    <template v-else>
        <router-link protect :to="{ name: adminProcessDetailRouteName, params: { type: processDetailType } }"
                     :class="processCounterCssClass(processCounter)">
            <aeg-icon :icon="processCounterIcon(processCounter)" />
            <span v-if="processCounter > 0">{{processCounter}}&nbsp;</span>{{processCounterText}}
        </router-link>
    </template>
</div>
